export interface Expense {
  id: string;
  title: string;
  amount: number;
  date: string;
  category: string;
  paymentMethod: string;
  reference: string;
  notes: string;
  fileUrl?: string;
  accountNumber?: string;
  chequeNumber?: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  status?: 'pending' | 'approved' | 'rejected';
  submittedByUid?: string;
  submittedByName?: string;
  submittedByEmail?: string;
  rejectionReason?: string;
  approvedByUid?: string;
  approvedByName?: string;
  approvedAt?: string;
  settlementMethod?: 'out_of_pocket' | 'against_advance';
  payrollSettled?: boolean;
}

export interface RecurringExpense {
  id: string;
  title: string;
  amount: number;
  startDate: string;
  endDate?: string;
  frequency: 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly';
  category: string;
  paymentMethod: string;
  notes: string;
  isActive: boolean;
  lastProcessed?: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
}

export const EXPENSE_CATEGORIES = [
  'Office Supplies',
  'Rent',
  'Utilities',
  'Salaries',
  'Travel',
  'Meals',
  'Equipment',
  'Software',
  'Marketing',
  'Insurance',
  'Taxes',
  'Maintenance',
  'Professional Services',
  'Miscellaneous'
];

export const PAYMENT_METHODS = [
  'Cash',
  'Bank Transfer',
  'Credit Card',
  'Debit Card',
  'UPI',
  'Check',
  'Digital Wallet'
];

export const FREQUENCIES = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'yearly', label: 'Yearly' }
]; 